import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const SkeletonCard: React.FC = () => {
    const { t } = useTranslation();
    return (
        <Card className="news-card skeleton-card">
            <div className="news-card-image-wrapper">
                <div className="news-card-image skeleton-image"></div>
                <span className="news-card-tag skeleton-tag"></span>
            </div>
            <Card.Body className="news-card-content">
                <div className="news-card-meta">
                    <span className="news-card-meta-item">
                        <div className="news-card-icon skeleton-icon"></div>
                        <div className="skeleton-text skeleton-date"></div>
                    </span>
                    <span className="news-card-meta-item">
                        <div className="news-card-icon skeleton-icon"></div>
                        <div className="skeleton-text skeleton-read-time"></div>
                    </span>
                </div>
                <Card.Title className="news-card-title">
                    <div className="skeleton-text skeleton-title"></div>
                    <div className="skeleton-text skeleton-title-short"></div>
                </Card.Title>
                <Card.Text className="news-card-description">
                    <div className="skeleton-text skeleton-description"></div>
                    <div className="skeleton-text skeleton-description"></div>
                    <div className="skeleton-text skeleton-description-short"></div>
                </Card.Text>
                <div className="news-card-footer">
                    <div className="news-card-link skeleton-link">
                        <div className="skeleton-text skeleton-link-text"></div>
                        <div className="news-card-icon skeleton-icon"></div>
                    </div>
                    <div className="news-card-share skeleton-share">
                        <div className="skeleton-text skeleton-share-text"></div>
                        <div className="news-card-icon skeleton-icon"></div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};
